/* eslint-disable eqeqeq */
import React from "react";
import dayjs from "dayjs";
import AcceptBatteryRequestIcon from "../../../Common/Svgs/AcceptBatteryRequestIcon";
import UserIcon from "../../../Common/Svgs/UserIcon";
import { AlertTriangleIcon } from "../../../Common/Svgs/AlertIcon";
import RequestIcon from "../../../Common/Svgs/RequestIcon";
import NewFarmerAddIcon from "../../../Common/Svgs/NewFarmerAddIcon";
import ItemBody1 from "./ItemBody1";
import ItemBody2 from "./ItemBody2";
import ItemBody3 from "./ItemBody3";
import ItemBody4 from "./ItemBody4";
import ItemBody5 from "./ItemBody5";
import ItemBody6 from "./ItemBody6";
import ItemBody7 from "./ItemBody7";
import ItemBody8 from "./ItemBody8";
import ItemBody9 from "./ItemBody9";
import ItemBody10 from "./ItemBody10";
import ItemBody13 from "./ItemBody13";
import ItemBody14 from "./ItemBody14";
import ItemBody15 from "./ItemBody15";
import ItemBody16 from "./ItemBody16";
import ItemBody17 from "./ItemBody17";
import ItemBody18 from "./ItemBody18";
import RentalBatteryRequestIcon from "../../../Common/Svgs/RentalBatteryRequestIcon";
import RentalIcon from "../../../Common/Svgs/RentalIcon";
import ChecklistFailedIcon from "../../../Common/Svgs/ChecklistFailedIcon";
import ItemBody19 from "./ItemBody19";
import StarIcon from "../../../Common/Svgs/StarIcon";
import ItemBody20 from "./ItemBody20";
import { NOTIFICATION_TYPE } from "./constants";
import ItemBody24 from "./ItemBody24";
import ItemBody25 from "./ItemBody25";
import EnergyPurchaseIcon from "../../../Common/Svgs/EnergyPurchaseIcon";
import ItemBody26 from "./ItemBody26";
import ItemBody27 from "./ItemBody27";
import ItemBody28 from "./ItemBody28";
import ItemBody30 from "./ItemBody30";
import SOSIcon from "../../../Common/Svgs/SOSIcon";

const NotificationItem = ({ notification, isLast }) => {
  const getIcon = () => {
    switch (+notification.type) {
      case 1:
        return <AlertTriangleIcon size={24} className="stroke-alert-red" />;
      case 2:
        return <AlertTriangleIcon size={24} className="stroke-warning" />;
      case 3:
        return <UserIcon size={24} className="stroke-warning fill-none" />;
      // same icon for type 4,5,6,7,8
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
        return <AcceptBatteryRequestIcon className="text-yellow-dark" />;
      case 9:
        return <AlertTriangleIcon size={24} className="stroke-warning" />;
      case 10:
        return <RequestIcon size={24} className="text-[#169757]" />;
      case 11:
        return <RequestIcon size={24} className="text-[#0892BD]" />;
      case 12:
        return <RequestIcon size={24} className="text-[#775DFA]" />;
      case 29:
        return <RequestIcon size={24} className="text-[#A25712]" />;

      case 13:
        return <NewFarmerAddIcon size={24} className="text-green" />;
      case 14:
      case 15:
        return <AlertTriangleIcon size={24} className="stroke-warning" />;
      case 16:
        return <RentalIcon size={24} className="text-green" />;
      // same icon for type 17,18
      case 17:
      case 18:
        return <RentalBatteryRequestIcon className="text-yellow-dark" />;
      case 19:
        return <StarIcon className="text-green" />;
      // same icon for type 20,21,22
      case 20:
      case 21:
      case 22:
        return <ChecklistFailedIcon size={24} />;
      case 24:
        return <RentalIcon size={24} className="text-green" />;
      case 25:
        return <EnergyPurchaseIcon size={24} />;
      case 26:
        return <RentalIcon size={24} className="text-green" />;
      case 27:
      case 28:
      case 30:
        return <SOSIcon />;
      default:
        return <div />;
    }
  };

  const getBody = () => {
    switch (+notification.type) {
      case 1:
        return <ItemBody1 notification={notification} />;
      case 2:
        return <ItemBody2 notification={notification} />;
      case 3:
        return <ItemBody3 notification={notification} />;
      case 4:
        return <ItemBody4 notification={notification} />;
      case 5:
        return <ItemBody5 notification={notification} />;
      case 6:
        return <ItemBody6 notification={notification} />;
      case 7:
        return <ItemBody7 notification={notification} />;
      case 8:
        return <ItemBody8 notification={notification} />;
      case 9:
        return <ItemBody9 notification={notification} />;
      case 10:
      case 11:
      case 12:
      case 29:
        // same body for all the incoming requests
        return <ItemBody10 notification={notification} />;
      case 13:
        return <ItemBody13 notification={notification} />;
      case 14:
        return <ItemBody14 notification={notification} />;
      case 15:
        return <ItemBody15 notification={notification} />;
      case 16:
        return <ItemBody16 notification={notification} />;
      case 17:
        return <ItemBody17 notification={notification} />;
      case 18:
        return <ItemBody18 notification={notification} />;
      case 19:
        return <ItemBody19 notification={notification} />;
      // same body for all checklist failed (trips, sessions, rentals)
      case 20:
      case 21:
      case 22:
        return <ItemBody20 notification={notification} />;
      case 24:
        return <ItemBody24 notification={notification} />;
      case 25:
        return <ItemBody25 notification={notification} />;
      case 26:
        return <ItemBody26 notification={notification} />;
      case 27:
        return <ItemBody27 notification={notification} />;
      case 28:
        return <ItemBody28 notification={notification} />;
      case 30:
        return <ItemBody30 notification={notification} />;
      default:
        return <div className="bg-black" />;
    }
  };


  const getClassName = () => {
    const infoNotifications = [
      NOTIFICATION_TYPE.TRIP_CHECKLIST_FAILED,
      NOTIFICATION_TYPE.SESSION_CHECKLIST_FAILED,
      NOTIFICATION_TYPE.RENTAL_CHECKLIST_FAILED,
      NOTIFICATION_TYPE.DRIVER_LICENSE_EXPIRE,
    ];

    if (infoNotifications.includes(+notification.type)) {
      if (isLast) return "rounded-b-xl";
      return "border-b border-light-grey";
    }

    if (notification?.metaData?.action == 1) {
      if (isLast) return "rounded-b-xl";
      return "border-b border-light-grey";
    }

    if (
      notification?.type == NOTIFICATION_TYPE.RENTAL_PURCHASE ||
      notification?.type == NOTIFICATION_TYPE.ENERGY_PURCHASE ||
      notification?.type == NOTIFICATION_TYPE.RENTAL_RECEIVED
    ) {
      return "min-h-20 border-b border-light-grey";
    }

    if (isLast) return "min-h-[140px] rounded-b-xl";

    return " border-b border-light-grey";
  };

  if (+notification.type === 7) {
    return null;
  }

  return (
    <div
      className={`py-4 px-6 hover:bg-background w-[312px] ${getClassName()}`}
    >
      <div className="flex items-center gap-x-2">
        {getIcon()}
        <p className="font-aileron text-10 font-normal text-dark-gray">
          {dayjs(notification?.submittedAt).format("DD-MM-YYYY, hh:mm a")}
        </p>
      </div>

      <div className="mt-1 ml-8">{getBody()}</div>
    </div>
  );
};

export default NotificationItem;
